export function arrayToCSV(rows: string[][]): string {
  return rows
    .map((row) =>
      row
        .map((cell) => {
          if (cell == null || cell === "") return "";

          // Detect numbers (integers or floats)
          const isNumber = /^-?\d+(\.\d+)?$/.test(cell);

          if (isNumber) {
            // IMPORTANT: do NOT quote numbers
            return cell;
          }

          // Escape text cells
          const escaped = cell.replace(/"/g, '""');
          return `"${escaped}"`;
        })
        .join(","),
    )
    .join("\n");
}

export function downloadCSV(csv: string, filename: string) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
